import React, { useEffect } from 'react';
import doc1 from '../static/pictures/Certificates_pictures/1.jpg'
import doc2 from '../static/pictures/Certificates_pictures/2.jpg'
import doc3 from '../static/pictures/Certificates_pictures/3.jpg'
import doc4 from '../static/pictures/Certificates_pictures/4.jpg'
import doc5 from '../static/pictures/Certificates_pictures/5.jpg'
import doc6 from '../static/pictures/Certificates_pictures/6.jpg'
import doc7 from '../static/pictures/Certificates_pictures/7.jpg'
import doc8 from '../static/pictures/Certificates_pictures/8.jpg'
import doc9 from '../static/pictures/Certificates_pictures/9.jpg'
import doc10 from '../static/pictures/Certificates_pictures/10.jpg'
import doc11 from '../static/pictures/Certificates_pictures/11.jpg'
import doc12 from '../static/pictures/Certificates_pictures/12.jpg'
import doc13 from '../static/pictures/Certificates_pictures/13.jpg'
import doc14 from '../static/pictures/Certificates_pictures/14.jpg'
import doc15 from '../static/pictures/Certificates_pictures/15.jpg'
import doc16 from '../static/pictures/Certificates_pictures/16.jpg'
import doc17 from '../static/pictures/Certificates_pictures/17.jpg'
import doc18 from '../static/pictures/Certificates_pictures/18.jpg'
import doc19 from '../static/pictures/Certificates_pictures/19.jpg'
import doc20 from '../static/pictures/Certificates_pictures/20.jpg'
import doc21 from '../static/pictures/Certificates_pictures/21.jpg'
import doc22 from '../static/pictures/Certificates_pictures/22.jpg'
import doc23 from '../static/pictures/Certificates_pictures/23.jpg'
import doc24 from '../static/pictures/Certificates_pictures/24.jpg'
//import "../static/css/About.css"
  

function About() {
    
useEffect(() => {
    const carousel = document.querySelector(".carousel");
    const prevButton = document.querySelector(".prev");
    const nextButton = document.querySelector(".next");

    if (!carousel || !prevButton || !nextButton) return;

    const tolerance = 1;
    let scrollAmount = window.innerWidth < 600 ? 233 : 1495;

    let isDragging = false;
    let startX = 0;
    let scrollLeftOnDragStart = 0;

    const scrollToPosition = (position) => {
        carousel.scrollLeft = position;
    };

    const handlePrevClick = () => {
        if (carousel.scrollLeft <= tolerance) {
            scrollToPosition(carousel.scrollWidth - carousel.clientWidth);
        } else {
            scrollToPosition(carousel.scrollLeft - scrollAmount);
        }
    };

    const handleNextClick = () => {
        if (carousel.scrollLeft >= carousel.scrollWidth - carousel.clientWidth - tolerance) {
            scrollToPosition(0);
        } else {
            scrollToPosition(carousel.scrollLeft + scrollAmount);
        }
    };

    const startDrag = (e) => {
        isDragging = true;
        carousel.classList.add("dragging");
        startX = e.pageX || e.touches[0].pageX;
        scrollLeftOnDragStart = carousel.scrollLeft;
        carousel.style.scrollBehavior = "auto";
    };

    const endDrag = () => {
        isDragging = false;
        carousel.classList.remove("dragging");
        carousel.style.scrollBehavior = "smooth";
    };

    const drag = (e) => {
        if (!isDragging) return;
        const x = e.pageX || e.touches[0].pageX;
        const walk = (x - startX) * 2;
        carousel.scrollLeft = scrollLeftOnDragStart - walk;
    };

    // Модальне вікно
    const modal = document.getElementById("myModal");
    const modalImg = document.getElementById("img");
    const captionText = document.getElementById("caption");
    const span = document.getElementsByClassName("close")[0];

    for (let i = 1; i <= 24; i++) {
        const img = document.getElementById(i);
        img.onclick = function () {
            modal.style.display = "block";
            modalImg.src = img.src;
            captionText.innerHTML = img.alt;
        };
    }

    span.onclick = function () {
        modal.style.display = "none";
    };

    // Мишка
    carousel.addEventListener("mousedown", startDrag);
    carousel.addEventListener("mousemove", drag);
    carousel.addEventListener("mouseup", endDrag);
    carousel.addEventListener("mouseleave", endDrag);

    // Тач-події
    carousel.addEventListener("touchstart", startDrag);
    carousel.addEventListener("touchmove", drag);
    carousel.addEventListener("touchend", endDrag);

    // Кнопки
    prevButton.addEventListener("click", handlePrevClick);
    nextButton.addEventListener("click", handleNextClick);

    return () => {
        carousel.removeEventListener("mousedown", startDrag);
        carousel.removeEventListener("mousemove", drag);
        carousel.removeEventListener("mouseup", endDrag);
        carousel.removeEventListener("mouseleave", endDrag);

        carousel.removeEventListener("touchstart", startDrag);
        carousel.removeEventListener("touchmove", drag);
        carousel.removeEventListener("touchend", endDrag);

        prevButton.removeEventListener("click", handlePrevClick);
        nextButton.removeEventListener("click", handleNextClick);
    };}, []);
        // Get the image and insert it inside the modal - use its "alt" text as a caption
    


    return(
        <div className='about_body'>
            <section className='first_section'>
                <div>
                    <h1>Про мене</h1>
                    <p>тут короткий вступ</p>
                </div>
            </section>
            <section className='section'>
                <div className='carousel_container'>
                    <button className="carousel-button prev">←</button>
                    <div className="carousel">
                        <div className='card'>
                            <img src={doc1} alt='doc' id='1'/> 
                        </div>

                        <div className='card'>
                            <img src={doc2} alt='doc' id='2'/>  
                        </div>

                        <div className='card'>
                            <img src={doc3} alt='doc' id='3'/> 
                        </div> 

                        <div className='card'>  
                            <img src={doc4} alt='doc' id='4'/>  
                        </div>

                        <div className='card'>
                            <img src={doc5} alt='doc' id='5'/>
                        </div> 

                        <div className='card'>
                            <img src={doc6} alt='doc' id='6'/> 
                        </div>

                        <div className='card'>
                            <img src={doc7} alt='doc' id='7'/>
                        </div>

                        <div className='card'>
                            <img src={doc8} alt='doc' id='8'/>
                        </div>

                        <div className='card'>
                            <img src={doc9} alt='doc' id='9'/> 
                        </div> 

                        <div className='card'>
                            <img src={doc10} alt='doc' id='10'/> 
                        </div>

                        <div className='card'>
                            <img src={doc11} alt='doc' id='11'/> 
                        </div> 

                        <div className='card'>
                            <img src={doc12} alt='doc' id='12'/>
                        </div>  

                        <div className='card'>
                            <img src={doc13} alt='doc' id='13'/>    
                        </div>

                        <div className='card'>
                            <img src={doc14} alt='doc' id='14'/>  
                        </div>

                        <div className='card'>
                            <img src={doc15} alt='doc' id='15'/> 
                        </div>

                        <div className='card'>
                            <img src={doc16} alt='doc' id='16'/> 
                        </div>

                        <div className='card'>
                            <img src={doc17} alt='doc' id='17'/>   
                        </div>

                        <div className='card'>
                            <img src={doc18} alt='doc' id='18'/> 
                        </div>

                        <div className='card'>
                            <img src={doc19} alt='doc' id='19'/> 
                        </div>

                        <div className='card'>
                            <img src={doc20} alt='doc' id='20'/> 
                        </div>

                        <div className='card'>
                            <img src={doc21} alt='doc' id='21'/>
                        </div>

                        <div className='card'>
                            <img src={doc22} alt='doc' id='22'/>
                        </div>

                        <div className='card'>
                            <img src={doc23} alt='doc' id='23'/>
                        </div>

                        <div className='card'>
                            <img src={doc24} alt='doc' id='24'/> 
                        </div>

                    </div>
                    <button className="carousel-button next">→</button>
                </div>
            </section>
            <div id="myModal" className="modal">
                <span className="close">&times;</span>
                <img className="modal-content" id="img" alt='foto in modal window'/>
                <div id="caption"></div>
            </div>
            <section className='text'>
                <h1>Про мій досвіт</h1>
                <p>
                    За першою освітою, я кандидат біологічних наук, генетик, 12 років займалася генетикою людини, за другою освітою і покликанням сімейний та кризовий психолог, психотерапевт. Люди завжи цікавили мене, як я шудкую з середини і ззовні😇тому генетика і психологія😉.  Приймаю очно та онлайн. Я  є асоційованим тренером НАГТУ ( Національна Асоціація Гештальт Терапевтів України), акредитованим гештальт-терапевтом, акредитованим супервізором НАГТУ, ведучою терапевтичних та супервізійних груп, та навчальних  програм, кандидатом наук, жінкою, мамою двох <del>дракончиків</del> підлітків.
                </p>
            </section>
        </div>
    );
}

export default About;